import EventListener from 'react-event-listener';
import PropTypes from 'prop-types';
import React from 'react';
import { UI_STATES } from '../reducers';
import '../../application/utils/polyfill';

const RESET_TIMEOUT = 5 * 1000;

export class UiEventHandlersComponent extends React.PureComponent {
  static propTypes = {
    canTouch: PropTypes.func.isRequired,
    setIdleUIState: PropTypes.func.isRequired,
    setControlsUIState: PropTypes.func.isRequired,
    uiState: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.ongoingTouches = [];

    this.state = {
      changeChannel: false,
    };

    this.resetBackToIdleTimeout();
  }

  onInteraction = (e) => {
    const hoverVideoPlayer = e.target.closest('div[data-layout]');

    if (this.props.uiState !== UI_STATES.CONTROLS && hoverVideoPlayer) {
      this.props.setControlsUIState();
      this.resetBackToIdleTimeout();
      this.setState({ changeChannel: false });
    }

    if (!hoverVideoPlayer && !this.state.changeChannel) {
      this.props.setIdleUIState();
    }
  };

  onTouchstart = (e) => {
    this.props.canTouch();
    this.ongoingTouches.push(...e.changedTouches);
    if (this.props.uiState !== UI_STATES.CONTROLS) {
      this.props.setControlsUIState();
    }
    clearTimeout(this.backToIdleTimeout);
  };

  onTouchend = (e) => {
    [].forEach.call(e.changedTouches, (changedTouch) => {
      const touchIndex = this.ongoingTouches.findIndex(
        (touch) => touch.identifier === changedTouch.identifier,
      );
      if (touchIndex > -1) {
        this.ongoingTouches.splice(touchIndex, 1);
      }
    });

    if (this.ongoingTouches.length === 0) {
      this.resetBackToIdleTimeout();
    }
  };

  handleChangeChannel = (e) => {
    const hoverVideoPlayer = e.target.closest('div[data-layout]');

    if (!hoverVideoPlayer) {
      this.setState({ changeChannel: true });
      this.props.setControlsUIState();
      this.resetBackToIdleTimeout();
    }
  };

  resetBackToIdleTimeout = () => {
    clearTimeout(this.backToIdleTimeout);
    this.backToIdleTimeout = setTimeout(() => {
      this.props.setIdleUIState();
    }, RESET_TIMEOUT);
  };

  render() {
    return (
      <EventListener
        target="window"
        onClick={this.handleChangeChannel}
        onKeyDown={this.onInteraction}
        onMouseMove={this.onInteraction}
        onWheel={this.onInteraction}
        onTouchStart={this.onTouchstart}
        onTouchEnd={this.onTouchend}
      />
    );
  }
}
